import { reduceNS } from '@reactive-redux/store';
import { produce } from 'immer';
import { isType } from 'ts-action';

import { addTeam } from './actions';
import { AppStateInterface } from './app.interface';

export const history = reduceNS<AppStateInterface, never>((state, action) =>
  produce(state, (draft) => {
    if (isType(action, addTeam)) {
      return;
    }

    const timestamp = new Date().getTime();

    draft.log[timestamp] = {
      action,
      timestamp,
      visible: true,
    };
  })
);

export const dbUpdates = reduceNS<AppStateInterface, never>((state, action) => {
  if (action.type.includes('[Backend]')) {
    // debugger;
  }
  return state;
});
